/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneProcessingQueryResponse, DocumentsControllerFindOneProcessingPathParams, DocumentsControllerFindOneProcessingQueryParams, DocumentsControllerFindOneProcessing400, DocumentsControllerFindOneProcessing401, DocumentsControllerFindOneProcessing403, DocumentsControllerFindOneProcessing404 } from "../../models/documentsController/DocumentsControllerFindOneProcessing";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindOneProcessing } from "../../clients/documentsService/documentsControllerFindOneProcessing";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindOneProcessingQueryKey = (id: DocumentsControllerFindOneProcessingPathParams["id"], processingId: DocumentsControllerFindOneProcessingPathParams["processingId"], params: DocumentsControllerFindOneProcessingQueryParams) => [{
  url: '/api/v1/documents/:id/processing/:processingId',
  params: {
    id: id,
    processingId: processingId
  }
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerFindOneProcessingQueryKey = ReturnType<typeof documentsControllerFindOneProcessingQueryKey>;
export function documentsControllerFindOneProcessingQueryOptions(id: DocumentsControllerFindOneProcessingPathParams["id"], processingId: DocumentsControllerFindOneProcessingPathParams["processingId"], params: DocumentsControllerFindOneProcessingQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindOneProcessingQueryKey(id, processingId, params);
  return queryOptions<DocumentsControllerFindOneProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneProcessing400 | DocumentsControllerFindOneProcessing401 | DocumentsControllerFindOneProcessing403 | DocumentsControllerFindOneProcessing404>, DocumentsControllerFindOneProcessingQueryResponse, typeof queryKey>({
    enabled: !!(id && processingId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindOneProcessing(id, processingId, params, config);
    }
  });
}

/**
 * @summary Get a processing job by ID
 * {@link /api/v1/documents/:id/processing/:processingId}
 */
export function useDocumentsControllerFindOneProcessing<TData = DocumentsControllerFindOneProcessingQueryResponse, TQueryData = DocumentsControllerFindOneProcessingQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindOneProcessingQueryKey>(id: DocumentsControllerFindOneProcessingPathParams["id"], processingId: DocumentsControllerFindOneProcessingPathParams["processingId"], params: DocumentsControllerFindOneProcessingQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindOneProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneProcessing400 | DocumentsControllerFindOneProcessing401 | DocumentsControllerFindOneProcessing403 | DocumentsControllerFindOneProcessing404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindOneProcessingQueryKey(id, processingId, params);
  const query = useQuery({
    ...documentsControllerFindOneProcessingQueryOptions(id, processingId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindOneProcessing400 | DocumentsControllerFindOneProcessing401 | DocumentsControllerFindOneProcessing403 | DocumentsControllerFindOneProcessing404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}